<template>
  <v-container>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>Lista de Itens Ordenável</span>
        <v-btn color="primary" @click="salvarOrdem">
          Salvar Ordem
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-data-table
        :headers="headers"
        :items="itens"
        item-key="id"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr :data-id="props.item.id" class="sortable-row">
            <td>{{ props.item.ordem }}</td>
            <td>{{ props.item.nome }}</td>
            <td class="text-center">
              <v-btn icon x-small color="primary" @click="moverPara(props.item.id, props.item.ordem - 1)" :disabled="props.item.ordem === 1">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn icon x-small color="primary" @click="moverPara(props.item.id, props.item.ordem + 1)" :disabled="props.item.ordem === itens.length">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
              <v-icon class="ml-2 drag-handle">mdi-drag</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      
      <v-expansion-panels v-if="debug">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Debug Info: Estado Atual dos Itens
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <pre>{{ JSON.stringify(itens, null, 2) }}</pre>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name: 'VuetifyDragDropTable',
  props: {
    debug: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: 'Ordem', value: 'ordem', width: '15%' },
        { text: 'Item', value: 'nome', width: '65%' },
        { text: 'Ações', value: 'actions', sortable: false, width: '20%', align: 'center' }
      ],
      itens: [
        { id: 1, ordem: 1, nome: 'Pão italiano' },
        { id: 2, ordem: 2, nome: 'Pão de Brioche' },
        { id: 3, ordem: 3, nome: 'Pão de Hamburguer' },
        { id: 4, ordem: 5, nome: 'Maionese' },
        { id: 5, ordem: 6, nome: 'Ketchup' },
        { id: 6, ordem: 7, nome: 'Parmesão' },
        { id: 7, ordem: 8, nome: 'Barbecue' },
        { id: 8, ordem: 9, nome: 'Cheddar' },
      ],
      sortable: null,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success'
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.inicializarSortable();
    });
  },
  methods: {
    inicializarSortable() {
      const tbody = document.querySelector('.v-data-table tbody');
  
  if (tbody) {
    this.sortable = Sortable.create(tbody, {
      animation: 150,
      ghostClass: 'sortable-ghost',
      onEnd: this.atualizarOrdemAposSortable,
      // Adicione esta linha para permitir arrastar toda a linha:
      handle: null // Remove a restrição do handle
    });
  } else {
    console.error('Não foi possível encontrar o tbody da tabela');
  }
    },
    atualizarOrdemAposSortable(evt) {
      const tbody = document.querySelector('.v-data-table tbody');
  if (!tbody) return;

  // Obtém todas as linhas da tabela em ordem atual (após arraste)
  const rows = Array.from(tbody.querySelectorAll('tr[data-id]'));

  // Recria uma nova lista com a ordem correta
  const novaLista = rows.map((row, index) => {
    const id = parseInt(row.getAttribute('data-id'));
    const item = this.itens.find(i => i.id === id);
    return {
      ...item,
      ordem: index + 1 // Nova ordem sequencial
    };
  });

  // Atualiza o array de itens
  this.itens = novaLista;

  // Reinicia o Sortable para funcionar novamente
  this.$nextTick(() => {
    if (this.sortable) {
      this.sortable.destroy();
    }
    this.inicializarSortable();
  });
},
renumerarTodos() {
  const item = this.itens.find(i => i.id === itemId);
  const currentIndex = item.ordem;

  if (novaOrdem < 1 || novaOrdem > this.itens.length || currentIndex === novaOrdem) return;

  // Move o item manualmente
  this.itens.forEach(i => {
    if (i.id === itemId) {
      i.ordem = novaOrdem;
    } else if (
      (currentIndex < novaOrdem && i.ordem > currentIndex && i.ordem <= novaOrdem) ||
      (currentIndex > novaOrdem && i.ordem >= novaOrdem && i.ordem < currentIndex)
    ) {
      i.ordem += currentIndex < novaOrdem ? -1 : 1;
    }
  });

  // Reordena e renumera corretamente
  this.renumerarTodos();
},
    moverPara(itemId, novaOrdem) {
  const item = this.itens.find(i => i.id === itemId);
  const currentIndex = item.ordem;
  
  if (novaOrdem < 1 || novaOrdem > this.itens.length || currentIndex === novaOrdem) return;

  // Move o item manualmente
  this.itens.forEach(i => {
    if (i.id === itemId) {
      i.ordem = novaOrdem;
    } else if (
      (currentIndex < novaOrdem && i.ordem > currentIndex && i.ordem <= novaOrdem) ||
      (currentIndex > novaOrdem && i.ordem >= novaOrdem && i.ordem < currentIndex)
    ) {
      i.ordem += currentIndex < novaOrdem ? -1 : 1;
    }
  });

  // Reordena e renumera corretamente
  this.renumerarTodos();
},
   
    salvarOrdem() {
      // Garantimos que os itens estão com ordens sequenciais antes de salvar
      this.renumerarTodos();
      
      // Aqui você incluiria o código para enviar a nova ordem para o backend
      console.log('Enviando nova ordem para o servidor:', this.itens);
      
      // Exemplo de como seria o SQL para atualizar no MySQL:
      const sql = this.itens.map(item => 
        `UPDATE sua_tabela SET ordem = ${item.ordem} WHERE id = ${item.id};`
      ).join('\n');
      
      console.log('SQL para atualização:', sql);
      
      // Mostra feedback ao usuário
      this.snackbarText = 'Nova ordem salva com sucesso!';
      this.snackbarColor = 'success';
      this.snackbar = true;
      
      // Emite evento para componente pai (opcional)
      this.$emit('ordem-atualizada', this.itens);
    },
    // Método para atualizar os itens de fonte externa (opcional)
    atualizarItens(novosItens) {
      this.itens = novosItens;
      this.$nextTick(() => {
        if (this.sortable) {
          this.sortable.destroy();
        }
        this.inicializarSortable();
      });
    }
  }
    }
</script>

<style scoped>
.sortable-ghost {
  opacity: 0.5;
  background-color: #e9f5ff !important;
}

.sortable-row {
  cursor: pointer;
}

.drag-handle {
  cursor: move;
}

/* Ensures the icon is visible in the Vuetify theme */
.v-icon.drag-handle {
  cursor: move;
  color: #757575;
}

/* Override Vuetify's default pointer */
.v-data-table tr {
  cursor: default;
}
.v-data-table tbody tr.sortable-ghost td {
  background-color: #f5f5f5 !important;
  opacity: 0.7;
}
.v-data-table tr.sortable-row {
  cursor: move; /* Mostra que a linha é arrastável */
}

.v-data-table tr.sortable-row:hover {
  background-color: #f5f5f5 !important;
}
.v-data-table tr.sortable-ghost td {
  background-color: #e0f7fa !important;
  opacity: 0.8;
}
</style>